// Runtime config — loaded from /assets/config/app-config.json before app renders.
// ES module `let` bindings are live: reassignment here is visible to all importers.

export let baseUrl = process.env.REACT_APP_API_URL
export let googleMapAPIKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY
export let environment = process.env.REACT_APP_ENV

export let firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
}

// Call before rendering the app. Overrides env vars with runtime config values.
export async function loadAppConfig() {
    try {
        const response = await fetch('/assets/config/app-config.json')
        const config = await response.json()

        if (config.apiBaseUrl) baseUrl = config.apiBaseUrl
        if (config.googleMapsApiKey) googleMapAPIKey = config.googleMapsApiKey
        if (config.environment) environment = config.environment
        if (config.firebase) firebaseConfig = { ...firebaseConfig, ...config.firebase }
    } catch (err) {
        console.warn('Failed to load app-config.json, using env vars:', err)
    }
}

// Static assets — not environment-dependent
export const userImg = "https://react.semantic-ui.com/images/avatar/small/matthew.png"
export const productImg = "https://i.stack.imgur.com/y9DpT.jpg"
export const mainModalStyle = {
  content: {
    border: '0',
    borderRadius: '4px',
    bottom: 'auto',
    left: '50%',
    position: 'fixed',
    right: 'auto',
    top: '50%',
    transform: 'translate(-50%,-50%)',
    minWidth: '20rem',
    width: '80%',
    maxWidth: '60rem',
    background: 'transparent',
    height: 'calc(100% - 50px)',
    overlfow: 'auto'
  }
}
